export type PlayerRatingBand = "developing" | "elite" | "limited" | "solid" | "strong";

export const getPlayerRatingMetric = (
  rating: number | undefined,
  hidden = false,
): {
  band?: PlayerRatingBand;
  score?: number;
} => {
  if (hidden || rating === undefined || !Number.isFinite(rating)) {
    return {};
  }

  const score = Math.max(0, Math.min(100, rating));
  const band: PlayerRatingBand =
    score >= 75
      ? "elite"
      : score >= 65
        ? "strong"
        : score >= 55
          ? "solid"
          : score >= 45
            ? "developing"
            : "limited";

  return { band, score };
};

export const getDraftRiskMetricScore = (risk: "hidden" | "high" | "medium" | "low") => {
  switch (risk) {
    case "high":
      return 20;
    case "medium":
      return 55;
    case "low":
      return 85;
    default:
      return undefined;
  }
};

export const getScoutingConfidenceMetricScore = (
  confidence: "high" | "low" | "medium" | "none",
) => {
  switch (confidence) {
    case "high":
      return 90;
    case "medium":
      return 60;
    case "low":
      return 25;
    default:
      return undefined;
  }
};
